import { Action } from '@ngrx/store';
import { IMemberProfileSpecialOccasion } from '@shared/shared/interfaces/member-profile-special-occasion.interfaces';

// Create special occasion
export const CREATE_PROFILE_SPECIAL_OCCASION = '[Member Profile] Create Profile Special Occasion';
export const CREATE_PROFILE_SPECIAL_OCCASION_SUCCESS = '[Member Profile] Create Profile Special Occasion Success';
export const CREATE_PROFILE_SPECIAL_OCCASION_FAIL = '[Member Profile] Create Profile Special Occasion Fail';

export class CreateProfileSpecialOccasion implements Action {
  readonly type = CREATE_PROFILE_SPECIAL_OCCASION;
  constructor(public payload: IMemberProfileSpecialOccasion) {}
}

export class CreateProfileSpecialOccasionSuccess implements Action {
  readonly type = CREATE_PROFILE_SPECIAL_OCCASION_SUCCESS;
  constructor(public payload: IMemberProfileSpecialOccasion) {}
}

export class CreateProfileSpecialOccasionFail implements Action {
  readonly type = CREATE_PROFILE_SPECIAL_OCCASION_FAIL;
}

// Destroy Special Occasion
export const DESTROY_PROFILE_SPECIAL_OCCASION = '[Member Profile] Destroy Profile Special Occasion';
export const DESTROY_PROFILE_SPECIAL_OCCASION_SUCCESS = '[Member Profile] Destroy Profile Special Occasion Success';
export const DESTROY_PROFILE_SPECIAL_OCCASION_FAIL = '[Member Profile] Destroy Profile Special Occasion Fail';

export class DestroyProfileSpecialOccasion implements Action {
  readonly type = DESTROY_PROFILE_SPECIAL_OCCASION;
  constructor(public payload: number) {}
}

export class DestroyProfileSpecialOccasionSuccess implements Action {
  readonly type = DESTROY_PROFILE_SPECIAL_OCCASION_SUCCESS;
  constructor(public payload: number) {}
}

export class DestroyProfileSpecialOccasionFail implements Action {
  readonly type = DESTROY_PROFILE_SPECIAL_OCCASION_FAIL;
}

// Update Special Occasion
export const UPDATE_PROFILE_SPECIAL_OCCASION = '[Member Profile] Update Profile Special Occasion';
export const UPDATE_PROFILE_SPECIAL_OCCASION_SUCCESS = '[Member Profile] Update Profile Special Occasion Success';
export const UPDATE_PROFILE_SPECIAL_OCCASION_FAIL = '[Member Profile] Update Profile Special Occasion Fail';

export class UpdateProfileSpecialOccasion implements Action {
  readonly type = UPDATE_PROFILE_SPECIAL_OCCASION;
  constructor(public payload: any) {}
}

export class UpdateProfileSpecialOccasionSuccess implements Action {
  readonly type = UPDATE_PROFILE_SPECIAL_OCCASION_SUCCESS;
  constructor(public payload: IMemberProfileSpecialOccasion) {}
}

export class UpdateProfileSpecialOccasionFail implements Action {
  readonly type = UPDATE_PROFILE_SPECIAL_OCCASION_FAIL;
}

export type MemberProfileSpecialOccasionAction =
  | CreateProfileSpecialOccasion
  | CreateProfileSpecialOccasionSuccess
  | CreateProfileSpecialOccasionFail
  | DestroyProfileSpecialOccasion
  | DestroyProfileSpecialOccasionSuccess
  | DestroyProfileSpecialOccasionFail
  | UpdateProfileSpecialOccasion
  | UpdateProfileSpecialOccasionSuccess
  | UpdateProfileSpecialOccasionFail;
